<div class="page-nav row">
    <div class="row sliding-menu-container">
        <div class="sliding-menu mybets-edit-bet-history-header">
            <div class="mybets-edit-bet-history-header-item-icon">
                <button class="edit-bet-history-icon" ds-button-icon size="medium" variant="flat-reduced" kind="tertiary" (click)="backToList()">
                    <vn-icon name="theme-left" size="16" />
                </button>
            </div>
            <div class="mybets-edit-bet-history-header-item">
                <span>{{ sitecoreMyBets.myBets.EditBetHistoryTitle }}</span>
            </div>
        </div>
    </div>
    <div class="clear"></div>
</div>
